var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C7.592 4 4 7.592 4 12C4 16.408 7.592 20 12 20C16.408 20 20 16.408 20 12C20 7.592 16.408 4 12 4ZM8.80005 11.2H12.8H15.2001C15.6419 11.2 16 11.5582 16 12C16 12.4419 15.6419 12.8 15.2001 12.8H11.2H8.80005C8.35822 12.8 8.00005 12.4419 8.00005 12C8.00005 11.5582 8.35822 11.2 8.80005 11.2ZM5.59961 11.9999C5.59961 15.5279 8.47161 18.3999 11.9996 18.3999C15.5276 18.3999 18.3996 15.5279 18.3996 11.9999C18.3996 8.4719 15.5276 5.5999 11.9996 5.5999C8.47161 5.5999 5.59961 8.4719 5.59961 11.9999Z",
    fill: "#B92E2A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default ForwardRef;